import { ListReportContainer } from "../../../containers/borrowSystem/Report/ListReportContainer"

export function ListReportPage() {
    return (
        <ListReportContainer />
    )
}